
/** 
* This file has been auto-generated by '@kontent-ai/model-generator@8.1.1'.
* 
* (c) Kontent.ai
*  
* -------------------------------------------------------------------------------
* 
* Project: UnumUK Employer Portal
* Environment: Dev (Previously Phase 2)
* Id: a5beabf7-cb3f-0126-9900-a0a631d69346
* 
* -------------------------------------------------------------------------------
**/

import type { Elements } from '@kontent-ai/delivery-sdk';
import type { ComponentInfoCard } from "./index.js";
import type { CoreContentType } from "../system/index.js";
import type { Products } from "../taxonomies/index.js";

/**
 * 🏗️ Component // Info Card Group
 *
 * Id: 43cb829f-44a4-4c1c-b1eb-8850edb98a21
 * Codename: info_card_group
 */
export type ComponentInfoCardGroup = CoreContentType<
    ComponentInfoCardGroupElementCodenames,
    {
        /**
         * Title
         *
         * Type: text
         * Required: false
         * Codename: title
         * Id: 95ff40dd-d044-4bc3-a704-88ffbcf21c07
         */
        readonly title: Elements.TextElement;
        /**
         * Intro
         *
         * Type: rich_text
         * Required: false
         * Codename: intro
         * Id: f18f4de6-e685-40c4-8912-8625e0be3ad1
         */
        readonly intro: Elements.RichTextElement<CoreContentType>;
        /**
         * Info Cards
         *
         * Type: modular_content
         * Required: true
         * Codename: info_cards
         * Id: 1bfa44f1-0476-468f-a7d4-b2b7faa4120b
         */
        readonly info_cards: Elements.LinkedItemsElement<ComponentInfoCard>;
        /**
         * Products
         *
         * Type: taxonomy
         * Required: false
         * Codename: products
         * Id: 185eaf86-547c-45bb-9ffb-86ce4548cbee
         * Guidelines: • Restrict the visibility of this content to selected products. • If no products are selected, the content will be visible to all users.
         */
        readonly products: Elements.TaxonomyElement<Products, 'products'>;
    },
    'info_card_group'
>;

/**
 * Type representing all available element codenames for 🏗️ Component // Info Card Group
 */
export type ComponentInfoCardGroupElementCodenames = 'title' | 'intro' | 'info_cards' | 'products';

/**
 * Type guard for 🏗️ Component // Info Card Group
 *
 * Id: 43cb829f-44a4-4c1c-b1eb-8850edb98a21
 * Codename: info_card_group
 */
export function isComponentInfoCardGroup(item: CoreContentType | undefined | null): item is ComponentInfoCardGroup {
    return item?.system?.type === 'info_card_group';
}
